import { EncryptionAttachmentEntity } from '../entities/EncryptionAttachment';
import { authResource } from './Auth';
import { paginatedEncryptionListSchema, paginatedSchema } from '../utils/schemas';
export const OrganizationEncryptionAttachmentResource = authResource({
    path: '/organizations/:organizationId/encryptions/attachments/:attachmentId?',
    searchParams: {},
    schema: EncryptionAttachmentEntity
})
    .extend('getList', {
    schema: paginatedSchema(EncryptionAttachmentEntity)
})
    .extend((BaseResource) => ({
    getBulkList: BaseResource.getList.extend({
        method: 'POST',
        body: {},
        schema: paginatedEncryptionListSchema(EncryptionAttachmentEntity),
        process: (response) => {
            var _a;
            return ({
                ...response,
                ids: (_a = response.ids) !== null && _a !== void 0 ? _a : []
            });
        },
        sideEffect: false
    })
}));
